module.exports = __webpack_public_path__ + "static/img/sb01.10328ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/sb01.png
// module id = nKZx
// module chunks = 1